import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { GoldPriceService } from '../../../../../app/shared/API-Service/services/GoldPrice.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-GoldPrice',
  templateUrl: './GoldPrice.component.html',
  styleUrls: ['./GoldPrice.component.css']
})
export class GoldPriceComponent implements OnInit {
  GoldPriceData:any [] = [];

  constructor(private GoldPrice:GoldPriceService, private _Router:Router) { }

   ngOnInit(): void {
      this.getGoldPrice();
    }
    getGoldPrice(){
      this.GoldPrice.GetGoldPrice().subscribe((res) => {
        this.GoldPriceData = res.data
      console.log(this.GoldPriceData);
      
      },(err)=>{
        console.log('their is a problem');
      },() =>{
        console.log('Completed');
      });
    }
  
    update(){
      this._Router.navigate(['/content/admin/InsertCity']);
      }
      
     

}
